import Modal from 'components/Modal/Modal';

import s from './ServiceProviderChangeModal.module.css';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
  onOKClick: () => void;
};

export const ServiceProviderChangeModal = ({
  isOpen,
  onClose,
  onOKClick,
}: TProps) => {
  return isOpen ? (
    <Modal
      title="Service Provider has Changed"
      className={s.modal}
      onClose={onClose}
    >
      <p>
        If you change service providers, you&apos;ll need to reselect the
        services for this appointment.
      </p>
      <p>
        To book 2 different service providers, please book 2 separate
        appointments.
      </p>
      <div className={s.buttons}>
        <button className={s.button} onClick={onOKClick}>
          OK
        </button>
        <button className={s.button} onClick={onClose}>
          Cancel
        </button>
      </div>
    </Modal>
  ) : null;
};
